import functions from "../../../../../world/spa/libs/vuexFunctions";

export default {
  namespaced: true,
  state: {
    objs: []
  },
  getters: {
    ...functions.createDefaultGetters(["idWorldProject"]),
    getAllByWork: (state, getters, rootState) => workFilter => {
      return state.objs.filter(project => {
        if (workFilter === "my") {
          return project.users && project.users.includes(rootState.auth.user.idWorldUser);
        } else {
          return project.developers.includes(workFilter);
        }
      });
    },
    getCustomers: (state, getters, rootState, rootGetters) => workFilter => {
      let customerIds = state.objs
        .filter(
          project =>
            project.developers.includes(workFilter) &&
            project.user === 0 &&
            project.customer !== ""
        )
        .map(project => project.customer);
      //Mediante l'utilizzo di Set elimino le ripetizioni
      return [...new Set(customerIds)].map(customerId =>
        rootGetters["works/get"](customerId)
      );
    }
  },
  mutations: {
    ...functions.createDefaultMutations(["idWorldProject"])
  },
  actions: {
    ...functions.createDefaultActionsWithStore(["idWorldProject"])
  }
};
